class Comparaison extends HTMLElement {
    constructor() {
        super();

        this.productId = '';
        this.quantity = 1;

        this.querySelectorAll(".custom-button-current").forEach((button) => {
            button.addEventListener('click', this.addToCart.bind(this))
        })

        this.swiper = new Swiper(this.querySelector('.comparaison-swiper'), {

            direction: 'horizontal',
            loop: false,
            cssMode: false,
            slidesPerView: 2,
            spaceBetween: 27,

            scrollbar: {
                el: this.querySelector('.swiper-scrollbar'),
            },
            breakpoints: {

                660: {
                    cssMode: false,
                    slidesPerView: 3,
                    spaceBetween: 27
                },

            }
        });
        this.swiperEvent()
        window.addEventListener('resize', this.swiperEvent.bind(this))

        this.updateHeightContent()
        window.addEventListener('resize', this.updateHeightContent.bind(this))
    }



    updateHeightContent() {
        const maxHeight = [];
        this.querySelectorAll('.comparaison-slide__details').forEach((item) => {
            maxHeight.push(item.offsetHeight);

        })

        this.querySelectorAll('.comparaison-slide__details').forEach((item) => {
            item.style.height = `${Math.max(...maxHeight)}px`;

        })

    }






    swiperEvent(e) {
        if (window.innerWidth < 990) {
            this.swiper.enable()
        }
        else {
            this.swiper.disable()
        }
    }

    addToCart(e) {

        this.productId = e.currentTarget.parentNode.querySelector('.input-quantity').value;
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: this.productId.toString(),
                quantity: 1
            })
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                document.dispatchEvent(new CustomEvent('cart:updated', {
                    bubbles: true,
                    detail: {
                        variant: this.productId,
                        quantity: 1
                    }
                }));
            });
    }

}

customElements.define('comparaison-product', Comparaison);